<template>
  <div>
    <div class="package-option-preview-modal__init-link-wrap">
      <a
        :class="siteIdentityClass('package-option-preview-modal__init-link')"
        href="#"
        @click.prevent="handlePreviewButtonClick"
      >
        {{ packageOption.CmsOptionGroupDetail.OpenModalCtaText }}
        <span
          v-if="showCtaIcon"
          class="fa fa-chevron-right"
        />
      </a>
    </div>
    <bootstrap-modal v-show="showModal">
      <div
        slot="header"
        class="modal-header"
      >
        <h2 class="package-option-preview-modal__head">{{ packageOption.CmsOptionGroupDetail.ModalTitle }}</h2>
        <button
          type="button"
          class="close modal__close-button"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModal = false"
        >
          <span
            aria-hidden="true"
            class="package-option-preview-modal__close-icon"
          >&times;</span>
        </button>
      </div>
      <div
        slot="body"
        class="modal-body package-option-preview-modal__body"
      >
        <div
          v-for="optionProduct in optionProductsWithDetail"
          :key="optionProduct.CatalogPackageOptionProductID"
          class="row package-option-preview-modal__img-row"
        >
          <div class="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-8 col-md-offset-2">
            <h3 class="package-option-preview-modal__item-head">{{ optionProduct.CmsProductDetail.ModalHeading }}</h3>
            <img
              :src="optionProduct.CmsProductDetail.ModalDetailImage.File.Url"
              :alt="optionProduct.CmsProductDetail.ModalHeading"
              class="responsive-img"
            >
            <div>
              <vue-markdown
                v-if="optionProduct.CmsProductDetail.ModalDescription"
                :source="optionProduct.CmsProductDetail.ModalDescription"
                class="package-option-preview-modal__description"
              />
            </div>
          </div>
        </div>
      </div>
    </bootstrap-modal>
  </div>
</template>

<script>
import BootstrapModal from '../BootstrapModal'
import VueMarkdown from 'vue-markdown'
import _ from 'lodash'
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'PackageOptionPreviewModal',
  components: {
    BootstrapModal,
    VueMarkdown
  },
  props: {
    packageOption: { type: Object, default: null }
  },
  data () {
    return {
      showModal: false
    }
  },
  computed: {
    modalClasses () {
      return {
        show: this.showModal === true
      }
    },
    optionProductsWithDetail () {
      return _.filter(this.packageOption.OptionProducts, (op) => {
        return op.CmsProductDetail !== null
      })
    },
    showCtaIcon () {
      return !this.isLetterJacket
    }
  },
  methods: {
    handlePreviewButtonClick () {
      GoogleAnalytics.trackEvent('See the Details Modal CTA', 'click', this.packageOption.Name)

      this.showModal = true
    }
  }
}
</script>

<style lang="scss">
.package-option-preview-modal {
  &__init-link {
    color: $grad-color-purple;
    font-size: 16px;
    font-weight: bold;

    &:hover {
      text-decoration: none;
      border-bottom: 2px solid $grad-color-purple;
    }

    &-wrap {
      margin-bottom: 10px;
    }

    &--letter-jacket {
      color: $letterjacket-color-blue;
      font-size: 16px;
      font-weight: 600;
      text-transform: uppercase;
      text-decoration: underline;

      &:hover {
        color: lighten($letterjacket-color-blue, 10%);
        border-bottom: transparent;
        text-decoration: underline;
      }
    }
  }

  &__img-row {
    margin-bottom: 20px;
  }

  &__head {
    margin: 0;
    padding: 0;
    font-family: $font-open-sans;
    font-weight: bold;
    font-size: 22px;
    display: inline-block;
  }

  &__body {
    max-height: 500px;
    overflow-y: auto;
  }

  &__item-head {
    margin-bottom: 10px;
    font-family: $font-open-sans;
    font-weight: bold;
  }

  &__description {
    margin-top: 20px;

    & > * {
      font-family: $font-open-sans;
    }
  }

  /*
  @media screen and (min-width: $screen-sm-min) {
  } */

  @media screen and (min-width: $screen-md-min) {
    &__item-head {
      text-align: center;
    }
  }

  /* @media screen and (min-width: $screen-lg-min) {
  }
  */
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/catalog/PackageOptionPreviewModal.vue